import {
  parseResponseBody,
  prepareBody,
  requestSocketPromiseWithTimeout,
} from '../../socket/query'
import * as SERVICE from '../../constants/service.types'

import { useSocketRequest } from '../../socket/useSocketRequest'

export const getChallengeAuthenticationWebAuthn = async (input) => {
  const response = await requestSocketPromiseWithTimeout({
    body: prepareBody(input),
    appServiceType: SERVICE.GET_CHALLENGE_AUTHENTICATION_WEB_AUTHN,
  })

  return parseResponseBody(response);
};

export const getChallengeAuthenRegisterWebAuthn = async (input) => {
  const response = await requestSocketPromiseWithTimeout({
    body: prepareBody(input),
    appServiceType: SERVICE.GET_CHALLENGE_AUTHEN_REGISTER_WEB_AUTHN,
  })

  return parseResponseBody(response);
};

export const registerWebAuthn = async (input) => {
  const response = await requestSocketPromiseWithTimeout({
    body: prepareBody(input),
    appServiceType: SERVICE.REGISTER_WEB_AUTHN,
  });

  return parseResponseBody(response);
};

export const checkLDAPAccount = async (input) => {
  const response = await requestSocketPromiseWithTimeout({
    body: prepareBody(input),
    appServiceType: SERVICE.CHECK_LDAP_ACCOUNT,
  })

  return parseResponseBody(response);
};

export const useCheckLDAPAccount = () => {
  return useSocketRequest({
    appServiceType: SERVICE.CHECK_LDAP_ACCOUNT,
  });
};

export const unregisterWebAuthn = async (input) => {
  const response = await requestSocketPromiseWithTimeout({
    body: prepareBody(input),
    appServiceType: SERVICE.UNREGISTER_WEB_AUTHN,
  });

  return parseResponseBody(response);
};